// https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html

console.log("firebaseee")

import firebase from 'firebase/app'
import 'firebase/firestore'
// import 'firebase/analytics'
import 'firebase/storage'
// import 'firebase/messaging'
import firebaseConfig from './firebaseConfig'
import firebaseConfigDev from './firebaseConfigDev'

// Initialize Firebase
if (process.env.NODE_ENV === 'production') {
  firebase.initializeApp(firebaseConfig)
} else {
  firebase.initializeApp(firebaseConfigDev)
}


// Firebase analytics (production only)
// const analytics = process.env.NODE_ENV === 'production' ? firebase.analytics() : null

// Firebase utils
const auth = firebase.auth()
const currentUser = () => auth.currentUser
const currentUserId = () => (auth.currentUser || {}).uid

// Initialize Firestore
const db = firebase.firestore()
const dbSettings = {}
db.settings(dbSettings)

// Initialize Storage
const storage = firebase.storage()


// let messaging = null

// if (firebase.messaging.isSupported()) {
//   messaging = firebase.messaging()
// }


export {
  auth,
  currentUser,
  currentUserId,
  db,
  storage,
}
